import React, {Component} from 'react';
import PoweredBy from 'components/general/poweredBy/PoweredBy';
import {getLocalizedStrings} from 'locale/i18n';
import './Computing.scss';
import Lahitapiola from '../svg/Lahitapiola';
import Saastopanki from '../svg/Saastopankki';
import Varma from '../svg/Varma';
import {connect} from "react-redux";
import {parseBoolean} from "../../../utils";

class Computing extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showLahitapiolaLogo: true,
      showSaastopankiLogo: true,
      showVarmaLogo: true,
      customLogoUrl: '',
      loadingTexts: [],
      currentTextIndex: 0,
      progress: 0,
      currentStep: 0
    };
    this.interval = null;
    this.progressInterval = null;
    this.stepInterval = null;
  }

  componentDidMount() {
    this.setState({
      ...this.props.app.config.computing
    });

    const loadingStage = this.props.loadingStage || 1;

    // Set progress duration based on stage
    const duration = loadingStage === 1 ? 6000 : 5000;

    // Progress steps based on duration
    const progressSteps = loadingStage === 1 ? [
      { time: 0, value: 0 },
      { time: 500, value: 8 },
      { time: 1100, value: 22 },
      { time: 1800, value: 28 },
      { time: 2600, value: 45 },
      { time: 3300, value: 52 },
      { time: 4000, value: 65 },
      { time: 4700, value: 78 },
      { time: 5200, value: 88 },
      { time: 5700, value: 96 },
      { time: 6000, value: 100 }
    ] : [
      { time: 0, value: 0 },
      { time: 500, value: 8 },
      { time: 1100, value: 22 },
      { time: 1800, value: 28 },
      { time: 2600, value: 45 },
      { time: 3300, value: 62 },
      { time: 4000, value: 82 },
      { time: 4700, value: 91 },
      { time: 5000, value: 100 }
    ];

    const startTime = Date.now();
    this.progressInterval = setInterval(() => {
      const elapsed = Date.now() - startTime;

      // Find the appropriate progress value based on elapsed time
      let targetProgress = 0;
      for (let i = 0; i < progressSteps.length; i++) {
        if (elapsed >= progressSteps[i].time) {
          targetProgress = progressSteps[i].value;
        } else {
          break;
        }
      }

      this.setState({ progress: targetProgress });

      // Stop after duration
      if (elapsed >= duration) {
        clearInterval(this.progressInterval);
      }
    }, 50);

    // Step text changes - for stage 1 (6 seconds), show 5 steps
    // for stage 2 (3 seconds), show 3 steps
    const strings = getLocalizedStrings(this.props.app.config.lang);
    const stepKey = loadingStage === 1 ? 'loading-steps-stage1' : 'loading-steps-stage2';
    const steps = strings[stepKey] || [];
    const stepDuration = duration / (steps.length || 1);

    this.stepInterval = setInterval(() => {
      this.setState(prevState => {
        const nextStep = prevState.currentStep + 1;
        if (nextStep >= steps.length) {
          clearInterval(this.stepInterval);
          return { currentStep: steps.length - 1 };
        }
        return { currentStep: nextStep };
      });
    }, stepDuration);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    if (this.stepInterval) {
      clearInterval(this.stepInterval);
    }
  }

  renderHeader(headerText, loadingStage) {
    // For Finnish stage 1, style "nen" in lighter color
    const lang = this.props.app.config.lang;
    if (lang === 'fi' && loadingStage === 1) {
      // Split "Yrityksesi kokoinen rahoitus" to highlight "nen"
      const parts = headerText.split('nen');
      if (parts.length === 2) {
        return (
          <h2 className="loading-header">
            {parts[0]}
            <span className="light-text">nen</span>
            {parts[1]}
          </h2>
        );
      }
    }
    return <h2 className="loading-header">{headerText}</h2>;
  }

  render () {
    const {progress, currentStep} = this.state;
    const strings = getLocalizedStrings(this.props.app.config.lang);
    const loadingStage = this.props.loadingStage || 1;

    const headerKey = loadingStage === 1
      ? 'loading-static-header-stage1'
      : 'loading-static-header-stage2';
    const bodyKey = loadingStage === 1
      ? 'loading-static-body-stage1'
      : 'loading-static-body-stage2';
    const stepKey = loadingStage === 1 ? 'loading-steps-stage1' : 'loading-steps-stage2';
    const steps = strings[stepKey] || [];
    const currentStepText = steps[currentStep] || '';

    return (
      <div className='computing-container app-container fade-animation'>
        <div className='progress-bar-container'>
          <div className='progress-bar'>
            <div className='progress-bar-fill' style={{width: `${progress}%`}}></div>
            <div className='progress-percentage'>{Math.round(progress)}%</div>
          </div>
          {currentStepText && (
            <div className='progress-step-text'>{currentStepText}</div>
          )}
        </div>
        <div className='loading-text' id='loading-text'>
          <div className="loading-content">
            {this.renderHeader(strings[headerKey], loadingStage)}
            <p className="loading-body">{strings[bodyKey]}</p>
          </div>
          <div className={`logos ${this.isAnyLogoShown() ? 'has-logo' : ''}`}>
            {this.state.showLahitapiolaLogo ? <Lahitapiola/> : null}
            {this.state.showSaastopankiLogo ? <Saastopanki/> : null}
            {this.state.showVarmaLogo ? <Varma/> : null}
            {this.state.customLogoUrl ? <img src={this.state.customLogoUrl} className={'custom-logo'} alt={''}/> : null}
          </div>

        </div>
        <div className='powered-by-container footer-powered-by'>
          <PoweredBy/>
        </div>
      </div>
    );
  }

  isAnyLogoShown() {
    const { showLahitapiolaLogo, showSaastopankiLogo, showVarmaLogo, customLogoUrl } = this.state;
    return showLahitapiolaLogo || showSaastopankiLogo || showVarmaLogo || !!customLogoUrl;
  }

  static normalizeArrayParamValue(value, fallback=[]) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      return value
        .split(',')
        .map(s => decodeURIComponent(s.trim()))
        .filter(Boolean);
    }
    return fallback;
  }

  static isEmpty(array = []) {
    return !array || array.length === 0
  }

  static getConfigFromParams(params = {}) {
    const {
      'computing.showLahitapiolaLogo': lahitapiolaParam,
      'computing.showSaastopankiLogo': saastopankiParam,
      'computing.showVarmaLogo': varmaParam,
      'computing.customLogoUrl': customLogoUrl,
      'computing.loadingTexts': loadingTextsParam
    } = params;
    return {
      showLahitapiolaLogo: parseBoolean(lahitapiolaParam),
      showSaastopankiLogo: parseBoolean(saastopankiParam),
      showVarmaLogo: parseBoolean(varmaParam),
      customLogoUrl,
      loadingTexts: Computing.normalizeArrayParamValue(loadingTextsParam)
    };
  }

}
export default connect(state => ({app: state.app}))(Computing);
